import { ErrorMessage, Field } from "formik";
import * as React from "react";
import "./styles.scss";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSSProperties, useMemo } from "react";

export interface InputProps {
  id: string;
  htmlFor?: string;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched?: (field: string, value: any) => void;
  component?: any;
  type?: string | "textarea" | "number";
  step?: number;
  rows?: number;
  disabled?: boolean;
  min?: number;
  max?: number;
  placeholder?: string;
  error?: boolean;
  onBlur?: (e: React.FocusEvent<any>) => void;
  onChange?: (e: React.ChangeEvent<any>) => void;
  onFocus?: () => void;
  className?: string;
  required?: boolean;
  rightIcon?: any;
  value?: string | number | null;
  showArrows?: boolean;
  isNoPadding?: boolean;
  maxLength?: number;
  innerRef?: (el: any) => void;
  appendElementText?: string;
  inputMode?: string;
  wrapperStyle?: CSSProperties;
  autoComplete?: string;
}

export default function KC_Input(props: InputProps) {
  const asProps = useMemo(() => {
    if (props.type && props.type !== "text" && props.type !== "number") {
      return props.type;
    }
    return "";
  }, [props.type]);

  const showArrows = useMemo(() => {
    return props.type === "number" && !props.rightIcon && props.showArrows;
  }, [props.type, props.rightIcon, props.showArrows]);

  function stepUp(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    const number_input: HTMLInputElement | null = document?.getElementById(
      props.id || ""
    ) as HTMLInputElement;
    if (number_input && props.type === "number") {
      number_input?.stepUp();
    }
  }

  function stepDown(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    const number_input: HTMLInputElement | null = document?.getElementById(
      props.id || ""
    ) as HTMLInputElement;
    if (number_input && props.type === "number") {
      number_input?.stepDown();
    }
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value =
      props.type === "number" ? e?.target?.valueAsNumber : e?.target?.value;

    props.setFieldValue(props.htmlFor || "", value);
  }

  function handleBlur(e: React.FocusEvent<HTMLInputElement>) {
    if (props.setFieldTouched) {
      props.setFieldTouched(props.htmlFor || "", true);
    }
    if (props.onBlur) {
      props.onBlur(e);
    }
  }

  const customClass = useMemo(() => {
    return `kc_input ${props.error ? " input_error" : ""} ${props.className ? props.className : ""} ${props.isNoPadding ? "kc-input-no-padding" : "kc-input-padding"}`;
  }, [props.className, props.error, props.isNoPadding]);

  return (
    <div className="d-flex flex-column gap-sm w-100">
      <div className="kc-input-wrapper flex-grow-1" style={props.wrapperStyle}>
        <Field
          id={props.id}
          name={props.htmlFor}
          htmlFor={props.htmlFor}
          className={customClass}
          type={props.type || "text"}
          as={asProps}
          step={props.step}
          component={props.component}
          rows={props.rows}
          disabled={props.disabled}
          min={props.min}
          max={props.max}
          maxLength={props.maxLength}
          placeholder={props.placeholder}
          onChange={handleChange}
          required={props.required}
          innerRef={props.innerRef}
          onFocus={props.onFocus}
          onBlur={handleBlur}
          inputMode={props.inputMode}
          onWheel={props.type === "number" ? blurOnWheel : undefined}
          autoComplete={props.autoComplete}
        />
        {props.appendElementText && (
          <div className="input-group-append">
            <span className="input-group-text">{props.appendElementText}</span>
          </div>
        )}

        {props.rightIcon && (
          <div className="input-group-append">
            <span
              className="input-group-text"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.03)",
                borderTop: "none",
                borderRight: "none",
                borderBottom: "none"
              }}
            >
              {props.rightIcon}
            </span>
          </div>
        )}
        {showArrows && (
          <div className="btn-container">
            <button onClick={stepUp} className={"input-step-up"}>
              <FontAwesomeIcon icon={faChevronUp} fontSize={12} />
            </button>
            <button onClick={stepDown} className={"input-step-down"}>
              <FontAwesomeIcon icon={faChevronDown} fontSize={12} />
            </button>
          </div>
        )}
      </div>
      <ErrorMessage
        name={props.htmlFor || props.id || ""}
        component="div"
        className="error-message"
      />
    </div>
  );
}

function blurOnWheel(e: any) {
  e?.target?.blur();
}
